var React = require('react');

function Facebook (props) {
    return React.createElement("svg",props,[React.createElement("g",{"key":0},React.createElement("g",{"id":"post-facebook"},React.createElement("path",{"d":"M459,0H51C22.95,0,0,22.95,0,51v408c0,28.05,22.95,51,51,51h408c28.05,0,51-22.95,51-51V51C510,22.95,487.05,0,459,0z\r\n\t\t\t M433.5,51v76.5h-51c-15.3,0-25.5,10.2-25.5,25.5v51h76.5v76.5H357V459h-76.5V280.5h-51V204h51v-63.75\r\n\t\t\tC280.5,91.8,321.3,51,369.75,51H433.5z"}))),React.createElement("g",{"key":1}),React.createElement("g",{"key":2}),React.createElement("g",{"key":3}),React.createElement("g",{"key":4}),React.createElement("g",{"key":5}),React.createElement("g",{"key":6}),React.createElement("g",{"key":7}),React.createElement("g",{"key":8}),React.createElement("g",{"key":9}),React.createElement("g",{"key":10}),React.createElement("g",{"key":11}),React.createElement("g",{"key":12}),React.createElement("g",{"key":13}),React.createElement("g",{"key":14}),React.createElement("g",{"key":15})]);
}

Facebook.defaultProps = {"version":"1.1","id":"Capa_1","x":"0px","y":"0px","width":"510px","height":"510px","viewBox":"0 0 510 510","style":{"enableBackground":"new 0 0 510 510"},"xmlSpace":"preserve"};

module.exports = Facebook;

Facebook.default = Facebook;



// WEBPACK FOOTER //
// ./src/images/icons/facebook.svg